export const generateKey = () => {
	const array = new Uint8Array(16);
	window.crypto.getRandomValues(array);
	return Array.from(array, (byte) => ('0' + byte.toString(16)).slice(-2)).join(
		'',
	);
};

export const importPublicKey = (base64PublicKey: string) => {
	const binaryDer = Uint8Array.from(atob(base64PublicKey), (c) =>
		c.charCodeAt(0),
	);

	return window.crypto.subtle.importKey(
		'spki',
		binaryDer.buffer,
		{
			name: 'RSA-OAEP',
			hash: { name: 'SHA-1' },
		},
		true,
		['encrypt'],
	);
};

export const encryptData = async (data: string, publicKey: CryptoKey) => {
	const encryptedData = await crypto.subtle.encrypt(
		{
			name: 'RSA-OAEP',
		},
		publicKey,
		new TextEncoder().encode(data),
	);

	return btoa(String.fromCharCode(...new Uint8Array(encryptedData)));
};
